// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__RGzhg","list":"styles_list__1aqiv"};